<template>
  <div>
    <employers-table v-if="multiEmployer"></employers-table>
  </div>
</template>

<script>
import EmployersTable from "../employer/EmployersTable";
export default {
  components: { EmployersTable },
  data () {
    return {
    }
  },
  computed: {
    ...amfx.map('session', 'employers'),
    ...amfx.map('actionItems', 'items'),
    singleEmployer() {
      if (!this.employers) return false;
      let singleEmployer = _.chain(this.employers).map(e => e.employerId).uniq().filter(e => e != null).value().length == 1;
      let newEmployer = this.items.find(i => i.itemType == 'ewf-new-employer-accept-tc') != null;      
      return { singleEmployer, newEmployer };
    },
    multiEmployer() {
      if(!this.employers) return false;
      return _.chain(this.employers).map(e => e.employerId).uniq().filter(e => e != null).value().length > 1;
    },
  },
  watch: {
    singleEmployer: {
      immediate: true,
      handler(v) {
        if(v.singleEmployer) {
          let employer = this.employers[0];
          if(v.newEmployer) {
            this.$router.push(`/employer/${employer.employerId}/order`);
          }
          else {
            this.$router.push(`/employer/${employer.employerId}/main`);
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/dashboards/EmployerDashboard.vue